import React, { useState } from 'react'
import {Badge} from '../..'
import { CloseRounded } from '@mui/icons-material'

import './readMore.css'

const ReadMore = ({onOpen, onClose}: any) => {

  return (
    <>
        {onOpen && (
            <>
                <div className='read-more-modal-wrapper'>
                    <div className={onOpen ? "read-more-modal-container active": "read-more-modal-container"}>
                        <Badge title="Our Story" />
                        <div className='read-more-close-modal' onClick={onClose}><CloseRounded /></div>
                        <div className='read-more-main-container'>
                            <div className="read-more-main-cover">
                                <h2 className='read-more-header'>Our Mission</h2>
                                <div className='read-more-text'>
                                    At Shalom Springs, we create a warm, supportive community where residents thrive. We deliver compassionate care, foster connections, and empower lives, nurturing mind, body, and spirit in a home-like environment.
                                </div>
                            </div>
                            <div className="read-more-main-cover">
                                <h2 className='read-more-header'>Our Values</h2>
                                <div className='read-more-text'>
                                    <div className='read-more-text-main'>
                                        <span className='read-more-bullet-wrapper'>
                                            <span className='read-more-bullet'></span>
                                        </span>
                                        <span>Patients and family first: We prioritize their needs, listen with empathy, and tailor care to their stories.</span>
                                    </div>
                                    <p className='read-more-text-main'>
                                        <span className='read-more-bullet-wrapper'>
                                            <span className='read-more-bullet'></span>
                                        </span>
                                        We take care of each other: Teamwork and kindness fuel our community's heartbeat.
                                    </p>
                                    <p className='read-more-text-main'>
                                        <span className='read-more-bullet-wrapper'>
                                            <span className='read-more-bullet'></span>
                                        </span>
                                        We do our best today and even better tomorrow: We innovate, learn, and grow to elevate care and joy.
                                    </p>
                                    <p className='read-more-text-main'>
                                        <span className='read-more-bullet-wrapper'>
                                            <span className='read-more-bullet'></span>
                                        </span>
                                        We are proud to make a difference: Every interaction matters, and together we create meaningful moments.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )}
    </>
  )
}

export default ReadMore